/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Table_Name_HeaderInputs */



/**
* | output |
* | --- |
* | "Name" |
*
* @param {Speakers_Table_Name_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_table_name_header = /** @type {((inputs?: Speakers_Table_Name_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Table_Name_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom")
	if (locale === "de") return /** @type {LocalizedString} */ ("Name")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Имя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("姓名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("名前")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome")
	return /** @type {LocalizedString} */ ("Name")
});